import { ShippingMethodEnum, ShippingProviderEnum } from "@/Apollo/schema";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemBrenger } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemBrenger";
import { ProductDeliveryOptionItemCourier } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemCourier";
import { ProductDeliveryOptionItemCustom } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemCustom";
import { ProductDeliveryOptionItemPickup } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemPickup";
import { ProductDeliveryOptionItemPostal } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemPostal";
import { ProductDeliveryOptionItemPostalSendcloud } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemPostalSendcloud";

type ProductDevliveryOptionsMap = Record<
  `${ShippingMethodEnum}-${ShippingProviderEnum | "NONE"}`,
  (props: ProductDeliveryOptionItemProps) => JSX.Element
>;

const PICKUP = `${ShippingMethodEnum.Pickup}-NONE`;
const COURIER = `${ShippingMethodEnum.Courier}-NONE`;
const BRENGER = `${ShippingMethodEnum.Courier}-${ShippingProviderEnum.Brenger}`;
const CUSTOM = `${ShippingMethodEnum.Custom}-NONE`;
const POSTAL = `${ShippingMethodEnum.Postal}-${ShippingProviderEnum.Wuunder}`;
const POSTAL_SENDCLOUD = `${ShippingMethodEnum.Postal}-${ShippingProviderEnum.Sendcloud}`;

/**
 * The `<method>` in the pdp and cart shipping test ids: the same method+provider
 * pairs PRODUCT_DELIVERY_OPTIONS_MAP keys on, so a flow names an option the same
 * way on both pages.
 */
const DELIVERY_OPTION_TEST_KEYS: Record<string, string> = {
  [PICKUP]: "pickup",
  [COURIER]: "courier",
  [BRENGER]: "brenger",
  [CUSTOM]: "custom",
  [POSTAL]: "postal-wuunder",
  [POSTAL_SENDCLOUD]: "postal-sendcloud",
};

export const deliveryOptionTestKey = (
  shippingMethod: string,
  shippingProvider?: string | null
): string | undefined =>
  DELIVERY_OPTION_TEST_KEYS[`${shippingMethod}-${shippingProvider ?? "NONE"}`];

export const PRODUCT_DELIVERY_OPTIONS_MAP: Partial<ProductDevliveryOptionsMap> =
  {
    [PICKUP]: ProductDeliveryOptionItemPickup,
    [COURIER]: ProductDeliveryOptionItemCourier,
    [BRENGER]: ProductDeliveryOptionItemBrenger,
    [CUSTOM]: ProductDeliveryOptionItemCustom,
    [POSTAL]: ProductDeliveryOptionItemPostal,
    [POSTAL_SENDCLOUD]: ProductDeliveryOptionItemPostalSendcloud,
  };
